/**
 * Resize ImageData to new dimensions
 * @param {ImageData} imageData - ImageData object
 * @param {number} newWidth - New width
 * @param {number} newHeight - New height
 * @returns {ImageData} - Resized ImageData
 */
export function resizeImageData(imageData, newWidth, newHeight) {
    if (imageData?.width === newWidth && imageData?.height === newHeight) {
        return imageData
    }
    const isWorker = typeof document === 'undefined'
    let canvas, tempCanvas

    if (isWorker) {
        canvas = new OffscreenCanvas(newWidth, newHeight)
        tempCanvas = new OffscreenCanvas(imageData.width, imageData.height)
    } else {
        canvas = document.createElement('canvas')
        canvas.width = newWidth
        canvas.height = newHeight
        tempCanvas = document.createElement('canvas')
        tempCanvas.width = imageData.width
        tempCanvas.height = imageData.height
    }

    const ctx = canvas.getContext('2d')
    const tempCtx = tempCanvas.getContext('2d')
    tempCtx.putImageData(imageData, 0, 0)

    ctx.drawImage(tempCanvas, 0, 0, newWidth, newHeight)

    return ctx.getImageData(0, 0, newWidth, newHeight)
}
